export function handleLineData(chartOption, res) {
    if(res.data.code===1) {
        // 里面包含两个数组分别对应经度和纬度
        // 经度数据
        let lineDataList1 = res.data.data.content.data[0].data;
        // 纬度数据
        let lineDataList2 = res.data.data.content.data[1].data;
        // 其他数据：目前仅考虑只有三组数据的情况
        let arrLen = res.data.data.content.data.length, hasOtherData = false, resData = []
        if(arrLen > 2){
          hasOtherData = true
          resData = res.data.data.content.data
        }
        let newCenterCity = {
            center:[parseFloat(lineDataList1[0].value),parseFloat(lineDataList2[0].value)],
            name:lineDataList1[0].key
        }
        this.$changeOptionsEV(newCenterCity, "chartOption.lines.centerData", false)
        let newLinesData = [];
        for(let i=0;i<lineDataList1.length;i++) {
            //  赋值经纬度之外数据
            let otherObj = {}
            if(hasOtherData){
              for(let j = 2;j < arrLen; j++){
                let nameN = "value" + j
                otherObj[`${nameN}`]= resData[j].data[i].value
              }
            }
            newLinesData.push([
                {
                  value: lineDataList1[i].key,
                  coord: [parseFloat(lineDataList1[i].value),parseFloat(lineDataList2[i].value)],
                    ...otherObj,
                },
                { coord: [parseFloat(lineDataList1[0].value),parseFloat(lineDataList2[0].value)] }
              ])
        }
        this.$changeOptionsEV(newLinesData, "chartOption.lines.data", false)
    }
 }
